/**
 * App.tsx
 * Root app with router and toaster. RTL layout enabled at page level.
 * Now wrapped with AuthGate for login protection.
 */

import { HashRouter, Route, Routes } from 'react-router'
import HomePage from './pages/Home'
import { Toaster } from 'sonner'
import { AuthGate } from './components/auth/AuthGate'
import { DataBackupFab } from './components/common/DataBackupFab'

export default function App() {
  return (
    <HashRouter>
      <AuthGate>
        <div className="min-h-screen bg-slate-50 text-slate-900">
          <Routes>
            <Route path="/" element={<HomePage />} />
          </Routes>
        </div>
      </AuthGate>
      <Toaster position="top-left" richColors />
    </HashRouter>
  )
}
